import { Daycare } from '@/types/Daycare.ts'
import { MealAccessibilitySection } from '@/types/Meal.ts'
import { TableCell, TableRow } from '@mui/material'
import { FunctionComponent, useState } from 'react'
import styles from '../meal.module.scss'
import { Delete } from '@mui/icons-material'
import EditIcon from '@mui/icons-material/Edit'
import DeleteMealAccessibilityDialog from './Dialog/DeleteMealAccessibilityDialog.tsx'
import UpdateMealAccessibilityDialog from './Dialog/UpdateMealAccessibilityDialog.tsx'
import moment from 'moment-timezone'
import { useTranslation } from 'react-i18next'

interface MealAccessibilityRowProps {
    accessibility: MealAccessibilitySection
    daycare: Daycare
    canUpdate: boolean
    refetch: () => void
    isRPEOrLAEP: boolean
}

const MealAccessibilityRow: FunctionComponent<MealAccessibilityRowProps> = ({
    accessibility,
    daycare,
    canUpdate,
    refetch,
    isRPEOrLAEP
}: MealAccessibilityRowProps) => {
    const { t } = useTranslation()
    const [deleteMealAccessibilityDialog, setDeleteMealAccessibilityDialog] = useState<boolean>(false)
    const [updateMealAccessibilityDialog, setUpdateMealAccessibilityDialog] = useState<boolean>(false)

    const mealTypeLabel: string = t(
        'mealType' + accessibility.type.charAt(0).toUpperCase() + accessibility.type.slice(1)
    )

    return (
        <>
            <TableRow>
                <TableCell>{accessibility.sectionName}</TableCell>
                <TableCell>{moment(accessibility.start, 'HH:mm:ss').format('HH:mm')}</TableCell>
                <TableCell>{mealTypeLabel}</TableCell>
                {canUpdate && (
                    <>
                        <TableCell>
                            <EditIcon className={styles.Icon} onClick={() => setUpdateMealAccessibilityDialog(true)} />
                        </TableCell>
                        <TableCell>
                            <Delete className={styles.Icon} onClick={() => setDeleteMealAccessibilityDialog(true)} />
                        </TableCell>
                    </>
                )}
            </TableRow>
            <DeleteMealAccessibilityDialog
                open={deleteMealAccessibilityDialog}
                handleClose={() => setDeleteMealAccessibilityDialog(false)}
                refetch={refetch}
                accessibilitySection={accessibility}
                daycareId={daycare.id}
            />
            <UpdateMealAccessibilityDialog
                open={updateMealAccessibilityDialog}
                handleClose={() => setUpdateMealAccessibilityDialog(false)}
                refetch={refetch}
                daycare={daycare}
                accessibilitySection={accessibility}
                isRPEOrLAEP={isRPEOrLAEP}
            />
        </>
    )
}

export default MealAccessibilityRow
